import Vue from 'vue';
import windowManager from 'manager/window-manager';
import { deepGetState, deepSetState, restore } from './util';



window.$ls = $.jStorage;



export default function factory(prefix) {
  const LS_PREFIX = prefix + '_';
  const EVENT_TAG = 'dn-ls-' + prefix;

  let watching = false;
  let restoreCancelTimerId = null;

  return {
    namespaced: true,

    state: {},

    getters: {
      prefix: state => prefix,
      at: (state, getters) => (keyMap, defaultValue) => deepGetState(state, keyMap, defaultValue),
      keys: state => Object.keys(state),
      all: state => {
        const data = {};
        for (let key in state) {
          data[key] = state[key];
        }
        return data;
      },
      selfcheckSubject: state => id => state[`selfcheck-subject-${id}`],
    },

    actions: {
      init: ({ commit, dispatch }) => {
        commit('restore', {force: true});
        restoreCancelTimerId = setTimeout(() => {
          restoreCancelTimerId = null;
        }, 500);
        dispatch('startWatch');
      },

      startWatch: ({ commit }) => {
        if (watching) return;
        watching = true;
        windowManager.on('show.' + EVENT_TAG, () => {
          commit('restore');
        });
      },

      stopWatch: ({ commit }) => {
        if (!watching) return;
        watching = false;
        windowManager.off('.' + EVENT_TAG);
      },

      set: ({ commit }, { keyMap, value }) => {
        commit('set', { keyMap, value });
      },

      setSelfcheckSubject: ({ commit, dispatch }, { id, data }) => {
        return dispatch('set', {keyMap: `selfcheck-subject-${id}`, value: data});
      },

      delete: ({ commit, dispatch, getters }, keyMap) => {
        if (getters['at'](keyMap, undefined) === undefined) return;
        return dispatch('set', { keyMap, value: undefined });
      },

      deleteKeys: ({ commit, dispatch, getters }, keyMaps) => {
        const targetKeys = keyMaps.filter(keyMap => getters['at'](keyMap, undefined) !== undefined);
        commit('deleteKeys', targetKeys);
      },

      deleteAll: ({ commit, dispatch, getters }) => {
        const keys = getters['keys'];
        commit('deleteKeys', keys);
      },
      deleteSelfcheckSubject: ({ dispatch }, id) => {
        return dispatch('delete', `selfcheck-subject-${id}`);
      },
    },

    mutations: {
      deleteKeys: (state, keys = []) => {
        for (let key of keys) {
          Vue.delete(state, key);
          $ls.deleteKey(LS_PREFIX + key);
        }
      },

      restore: (state, opt = {}) => {
        if (opt.force || restoreCancelTimerId === null) {
          restore(state, LS_PREFIX);
        }
      },

      set: (state, { keyMap, value }) => {

        // 参照を断ち切るためオブジェクトだったらクローンしておく
        if (typeof value === 'object') value = JSON.parse(JSON.stringify(value));
        return deepSetState(state, keyMap, value, LS_PREFIX);
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ls/factory.js